var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNbaaMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 72",
    style: {
      enableBackground: "new 0 0 380 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002D73;}\r\n\t.st1{fill:#2F292B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,14.9C28.4,3.3,53.1-2.8,75,5.5C56.6,4,24,12.2,15.6,14.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,18.8c10.9-3.1,57.5-15.7,73.4-8.2c3.6,2.2,7.3,6.2,8.1,7.1c-23.1-9.8-81.1,6.2-85.4,8.2 C9.1,23.4,10.5,19.9,11.9,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,29.8c15.7-5.5,71.1-19.2,90-7c1.1,2.4,2,5.7,2.6,7.6c-16.9-16.6-83.8,1.4-92.9,5.9 C6.2,34.9,6.7,30.4,6.9,29.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,37.4c10.5,2.4,81.3,5.9,93.2-2.2c-0.2,2.6-1,6.1-1.4,7.2C86.9,50.3,14.9,46,8.5,44.1 C7.9,42.5,6.6,38.4,6.6,37.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,47.7c9.3,1.4,78.4,4.8,86.3-1.7c-1.8,3.5-5.6,7.5-7.4,8.9c-11.1,3-70.1,1.4-73.2-0.7 C15,53.2,11.8,50,10.5,47.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,58c12.7,2,52.5,2.7,63.1,0.7C69.7,68.7,38.5,70.2,20.9,58"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "123.8,13.8 132.2,13.8 169.1,45.3 169.1,13.8 176.7,13.8 176.7,54.3 169.5,54.3 131.4,21.8  131.4,54.3 123.8,54.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.5,47.7c5,0,8.8-1,8.8-5.8c0-4.2-3.5-5.6-8.8-5.6h-27.1v11.4H225.5z M225.3,29.8c5.2,0,7.5-1.3,7.5-4.7 c0-3.5-2.3-4.7-7.5-4.7h-26.9v9.4H225.3z M190.5,13.8h34.3c9.5,0,15.9,2.7,15.9,10.4c0,5.1-2.5,7-4.7,8.4 c2.8,1.2,6.2,4.7,6.2,10c0,7.6-6.1,11.7-15.9,11.7h-35.8V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M261.5,31.9v-7.7c0.2-3.2,3.1-4.5,8.1-4.5h22.2c5.2,0,7.9,1.3,7.9,4.7l0,0.1v7.3H261.5z M307.1,23.5 c0-7.6-6.5-10.3-16-10.3h-21c-9.5,0-15.9,2.7-15.9,10.3h0V54h7.4V38.5h38.3V54h7.4L307.1,23.5L307.1,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.9,31.9v-7.7c0.2-3.2,3.1-4.5,8.1-4.5h22.3c5.2,0,7.9,1.3,7.9,4.7l0,0.1v7.3H327.9z M373.6,23.5 c0-7.6-6.5-10.3-16-10.3h-21c-9.5,0-15.9,2.7-15.9,10.3h0V54h7.4V38.5h38.3V54h7.4L373.6,23.5L373.6,23.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.4,60.7v9.5h-1.7l-3.7-8.2h0v8.2h-1.1v-9.5h1.7l3.7,8.1h0v-8.1H131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,60.7h1.5l3.1,9.5H139l-0.7-2.3h-3.7l-0.7,2.3h-1.2L135.8,60.7z M136.5,61.8L136.5,61.8l-1.5,5h3L136.5,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,60.7v1h-2.5v8.4h-1.2v-8.4h-2.5v-1H146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,70.1h-1.2v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,66.7v-3.1c0-1.9,1-3.1,3-3.1s3,1.2,3,3.1v3.1c0,2.6-1,3.7-3,3.7S150.8,69.3,150.8,66.7z M155.5,66.7v-3.2 c0-2-1.4-2-1.7-2c-0.4,0-1.7,0.1-1.7,2v3.2c0,2.1,0.6,2.6,1.7,2.6C154.9,69.3,155.5,68.8,155.5,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4,60.7v9.5h-1.7l-3.7-8.2h0v8.2h-1.1v-9.5h1.7l3.7,8.1h0v-8.1H165.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7,60.7h1.5l3.1,9.5H173l-0.7-2.3h-3.7l-0.7,2.3h-1.2L169.7,60.7z M170.5,61.8L170.5,61.8l-1.5,5h3L170.5,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,70.1v-9.5h1.2v8.4h3.5v1H175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4,70.1v-9.5h3.1c1.3,0,1.8,0.4,2.1,1c0.3,0.5,0.4,1.1,0.4,1.3c0,1.2-0.4,2-1.6,2.2v0.1c1.4,0.2,1.9,1,1.9,2.3 c0,2.4-1.8,2.7-2.8,2.7H184.4z M185.6,64.7h1.8c0.9,0,1.4-0.6,1.4-1.5c0-0.8-0.4-1.4-1.5-1.4h-1.7V64.7z M185.6,69.1h1.7 c1.3,0,1.7-0.9,1.7-1.6c0-1.5-0.9-1.8-2.2-1.8h-1.3V69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.3,60.7h1.2v6.1c0,2.1,0.6,2.6,1.8,2.6c1.1,0,1.8-0.5,1.8-2.6v-6.1h1.2v6c0,2.6-1,3.7-3,3.7s-3-1-3-3.7V60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,67.3v0.3c0,1.3,0.8,1.7,1.6,1.7c1,0,1.7-0.4,1.7-1.5c0-2.1-4.2-1.9-4.2-4.7c0-1.7,1.2-2.6,2.8-2.6 c1.7,0,2.7,0.8,2.6,2.8h-1.3c0-1-0.3-1.7-1.5-1.7c-0.7,0-1.5,0.4-1.5,1.4c0,2.1,4.2,1.8,4.2,4.8c0,2-1.4,2.6-2.9,2.6 c-2.8,0-2.8-2.1-2.8-3H201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,70.1h-1.2v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,60.7v9.5h-1.7l-3.7-8.2h0v8.2h-1.1v-9.5h1.7l3.7,8.1h0v-8.1H217.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,70.1v-9.5h4.9v1h-3.7v3h3.4v1h-3.4v3.3h3.7v1H220z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.5,67.3v0.3c0,1.3,0.8,1.7,1.6,1.7c1,0,1.7-0.4,1.7-1.5c0-2.1-4.2-1.9-4.2-4.7c0-1.7,1.2-2.6,2.8-2.6 c1.7,0,2.7,0.8,2.6,2.8h-1.3c0-1-0.3-1.7-1.5-1.7c-0.7,0-1.5,0.4-1.5,1.4c0,2.1,4.2,1.8,4.2,4.8c0,2-1.4,2.6-2.9,2.6 c-2.8,0-2.8-2.1-2.8-3H227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,67.3v0.3c0,1.3,0.8,1.7,1.6,1.7c1,0,1.7-0.4,1.7-1.5c0-2.1-4.2-1.9-4.2-4.7c0-1.7,1.2-2.6,2.8-2.6 c1.7,0,2.7,0.8,2.6,2.8h-1.3c0-1-0.3-1.7-1.5-1.7c-0.7,0-1.5,0.4-1.5,1.4c0,2.1,4.2,1.8,4.2,4.8c0,2-1.4,2.6-2.9,2.6 c-2.8,0-2.8-2.1-2.8-3H234.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1,60.7h1.5l3.1,9.5h-1.3l-0.7-2.3h-3.7l-0.7,2.3h-1.2L246.1,60.7z M246.9,61.8L246.9,61.8l-1.5,5h3L246.9,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.8,70.1h-1.4l-2.7-9.5h1.3l2.2,8.3h0l2.2-8.3h1.2L254.8,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,70.1H259v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.6,60.7h1.5l3.1,9.5h-1.4l-0.7-2.3h-3.7l-0.7,2.3h-1.2L264.6,60.7z M265.3,61.8L265.3,61.8l-1.5,5h3L265.3,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,60.7v1h-2.5v8.4h-1.2v-8.4h-2.5v-1H274.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,70.1h-1.2v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,66.7v-3.1c0-1.9,1-3.1,3-3.1c2,0,3,1.2,3,3.1v3.1c0,2.6-1,3.7-3,3.7C280.6,70.3,279.6,69.3,279.6,66.7z  M284.4,66.7v-3.2c0-2-1.4-2-1.7-2c-0.4,0-1.7,0.1-1.7,2v3.2c0,2.1,0.6,2.6,1.7,2.6C283.8,69.3,284.4,68.8,284.4,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.2,60.7v9.5h-1.7l-3.7-8.2h0v8.2h-1.1v-9.5h1.7l3.7,8.1h0v-8.1H294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5,60.7h1.5l3.1,9.5h-1.4l-0.7-2.3h-3.7l-0.7,2.3h-1.2L301.5,60.7z M302.2,61.8L302.2,61.8l-1.5,5h3L302.2,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.3,67.3v0.3c0,1.3,0.8,1.7,1.6,1.7c1,0,1.7-0.4,1.7-1.5c0-2.1-4.2-1.9-4.2-4.7c0-1.7,1.2-2.6,2.8-2.6 c1.7,0,2.7,0.8,2.6,2.8h-1.3c0-1-0.3-1.7-1.5-1.7c-0.7,0-1.5,0.4-1.5,1.4c0,2.1,4.2,1.8,4.2,4.8c0,2-1.4,2.6-2.9,2.6 c-2.8,0-2.8-2.1-2.8-3H308.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5,67.3v0.3c0,1.3,0.8,1.7,1.6,1.7c1,0,1.7-0.4,1.7-1.5c0-2.1-4.2-1.9-4.2-4.7c0-1.7,1.2-2.6,2.8-2.6 c1.7,0,2.7,0.8,2.6,2.8h-1.3c0-1-0.3-1.7-1.5-1.7c-0.7,0-1.5,0.4-1.5,1.4c0,2.1,4.2,1.8,4.2,4.8c0,2-1.4,2.6-2.9,2.6 c-2.8,0-2.8-2.1-2.8-3H315.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,66.7v-3.1c0-1.9,1-3.1,3-3.1c2,0,3,1.2,3,3.1v3.1c0,2.6-1,3.7-3,3.7C322.8,70.3,321.9,69.3,321.9,66.7z  M326.6,66.7v-3.2c0-2-1.4-2-1.7-2s-1.7,0.1-1.7,2v3.2c0,2.1,0.6,2.6,1.7,2.6S326.6,68.8,326.6,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1,63.3c0-0.5,0-1.1-0.3-1.4c-0.2-0.3-0.8-0.4-1.1-0.4c-1,0-1.4,0.6-1.4,0.7c0,0.1-0.3,0.3-0.3,2v2.5 c0,2.3,0.8,2.6,1.7,2.6c0.4,0,1.5-0.1,1.5-2h1.2c0.1,3-2.1,3-2.7,3c-1.2,0-3-0.1-3-3.7v-2.7c0-2.7,1.2-3.4,3-3.4 c1.9,0,2.6,1,2.5,2.8H334.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5,70.1h-1.2v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,60.7h1.5l3.1,9.5h-1.3l-0.7-2.3h-3.7l-0.7,2.3H340L343,60.7z M343.7,61.8L343.7,61.8l-1.5,5h3L343.7,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,60.7v1h-2.5v8.4h-1.2v-8.4H347v-1H353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.8,70.1h-1.2v-9.5h1.2V70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,66.7v-3.1c0-1.9,1-3.1,3-3.1c2,0,3,1.2,3,3.1v3.1c0,2.6-1,3.7-3,3.7C359,70.3,358,69.3,358,66.7z M362.7,66.7v-3.2 c0-2-1.4-2-1.7-2s-1.7,0.1-1.7,2v3.2c0,2.1,0.6,2.6,1.7,2.6S362.7,68.8,362.7,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.6,60.7v9.5H371l-3.7-8.2h0v8.2h-1.1v-9.5h1.7l3.7,8.1h0v-8.1H372.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbaaMainLogo);
export default __webpack_public_path__ + "static/media/nbaa-main-logo.ce4a6dbbc68ee3485f685c9beb63144c.svg";
export { ForwardRef as ReactComponent };